import api from '../../api'
import { endpoints } from '../../apiCommons'

const refreshToken = async () => {
  const token = localStorage.getItem('token')
  return api.get(endpoints.refreshToken, {
    headers: { token },
  })
}

export default {
  refreshToken,
}
